import React, { Component, PropTypes } from 'react';
import Rating from '../../tc-ui/rating';
import Icon from '../../tc-ui/icon';
import { assoc, always, ifElse, compose, any, isNil, values } from 'ramda';

class RatingNode extends Component {

  render() {
    const { profileToShow, editField, routeName, isEditable, isSingleLocSupplier } = this.props;
    const rating = profileToShow.rating;

    const baseSettings = {
      type: 'rating',
      isRequired: true,
    };

    const ratingSettings = ifElse(
      compose(any(isNil), values),
        () => assoc('initialValue', {
          value: 3,
          type: 'Self-Assessed',
        }, baseSettings),
      always(baseSettings));

    const editRatingIcon = (
      <div
        style={{ display: 'inline-block', marginLeft: '8px', marginTop: '12px' }}
        className="profile-edit-icon-container"
        onClick={editField.bind(this, 'rating', ratingSettings(rating))}
      >
        <Icon className="tc-icon-mode_edit profile-edit-icon"/>
        {rating && rating.type ? 'EDIT' : (() => {
          let routeDisplay = '';
          if (routeName === 'profile') routeDisplay = 'Company';
          if (routeName === 'location') routeDisplay = 'Location';
          return `Add ${routeDisplay} Rating`;
        })()
        }
      </div>
    );

    if ((routeName === 'location' || isSingleLocSupplier) && profileToShow.productType === 'accommodation' && (rating && Object.keys(rating).length || isEditable)) {
      return (
        <div id="rating">
          <Rating
            style={(profileToShow.coverImageUrl ? undefined : { color: 'rgba(0, 0, 0, 0.87)' })}
            rating={rating}
            isEditable={isEditable}
            innerClass="inner-description"
          />
          {isEditable && (routeName === 'location' || isSingleLocSupplier) ? editRatingIcon : undefined}
        </div>
      );
    }
    return false;
  }
}

RatingNode.propTypes = {
  profileToShow: PropTypes.object,
  editField: PropTypes.func,
  routeName: PropTypes.string,
  isEditable: PropTypes.bool,
  isSingleLocSupplier: PropTypes.bool,
};

export default RatingNode;



// WEBPACK FOOTER //
// ./src/app/components/profile/profile-top-bar/rating-node.jsx